import { Box, Switch, Text, Tooltip } from '@optiaxiom/react';

import { useRegistryChatStats, useRegistryChatTooltip } from './hooks';
import type { RegistryChatToggleProps } from './types';

export function RegistryChatToggle({
  toolRow,
  onBulkToggleChatEnabled,
  isLoading,
}: RegistryChatToggleProps) {
  const { allEnabled, allDisabled, enabledCount, totalCount, toolNames, allToolsDisabled } =
    useRegistryChatStats(toolRow);

  const tooltipContent = useRegistryChatTooltip(
    allToolsDisabled,
    totalCount,
    allEnabled,
    allDisabled,
    enabledCount
  );

  if (!toolRow.isRegistry) {
    return null;
  }

  const handleToggle = () => {
    if (totalCount === 0 || allToolsDisabled) return;

    // If all are disabled in chat, enable all. Otherwise, disable all.
    const action = allDisabled ? 'enable' : 'disable';
    onBulkToggleChatEnabled(toolNames, action);
  };

  return (
    <Tooltip content={tooltipContent}>
      <Box display="flex" alignItems="center" gap="8">
        <Switch
          disabled={isLoading || totalCount === 0 || allToolsDisabled}
          checked={!allDisabled}
          onCheckedChange={handleToggle}
          aria-label={`Toggle all tools in ${toolRow.name} for chat`}
        />
        <Text fontSize="sm" color="fg.secondary">
          {enabledCount}/{totalCount}
        </Text>
      </Box>
    </Tooltip>
  );
}
